{
  "addToFavorites": "पसंदीदा में जोड़ें",
  "alertCondition": "अलर्ट की शर्त",
  "alertCreateFailed": "मूल्य अलर्ट बनाने में विफल।",
  "alertCreated": "मूल्य अलर्ट बनाया गया।",
  "alertTargetValue": "अलर्ट लक्ष्य मूल्य",
  "allChains": "सभी चेन",
  "allMarkets": "सभी",
  "buyToken": "कॉइन खरीदें",
  "chain": "Chain",
  "change24h": "24 घंटे बदलाव",
  "chart": "चार्ट",
  "coin": "Coin",
  "contract": "कॉन्ट्रैक्ट",
  "contractCopied": "कॉन्ट्रैक्ट कॉपी हो गया।",
  "createAlert": "अलर्ट बनाएं",
  "exchange": "एक्सचेंज",
  "favorite": "पसंदीदा",
  "filteredCoins": "फ़िल्टर किए गए कॉइन",
  "gainers": "लाभ में",
  "holders": "Holders",
  "hot": "हॉट",
  "invalidAlertValue": "एक मान्य धनात्मक संख्या दर्ज करें।",
  "lastUpdated": "आखिरी बार अपडेट किया गया",
  "liquidity": "लिक्विडिटी",
  "live": "लाइव",
  "liveMarketBoard": "● लाइव मार्केट बोर्ड",
  "loading": "लोड हो रहा है...",
  "loadingMarkets": "मार्केट लोड हो रही है...",
  "losers": "हानि में",
  "marketCap": "मार्केट कैप",
  "marketCategories": "बाजार श्रेणियां",
  "marketStatus": "मार्केट स्टेटस",
  "marketsSubtitle": "स्वीकृत कॉइन, सत्यापित कॉन्ट्रैक्ट, लाइव चार्ट, लिक्विडिटी और वॉल्यूम।",
  "marketsTitle": "EXALT बाज़ार",
  "noApprovedCoins": "कोई स्वीकृत कॉइन नहीं मिला।",
  "noContractFound": "कोई कॉन्ट्रैक्ट नहीं मिला।",
  "percentChange": "% से बदले",
  "percentPlaceholder": "उदा. 5",
  "price": "कीमत",
  "priceAbove": "कीमत इससे ऊपर बढ़े",
  "priceAlerts": "मूल्य अलर्ट",
  "priceBelow": "कीमत इससे नीचे गिरे",
  "pricePlaceholder": "उदा. 50000",
  "refresh": "रिफ्रेश",
  "removeFromFavorites": "पसंदीदा से हटाएं",
  "searchCoin": "कॉइन खोजें...",
  "staleMarketBoard": "⚠ कीमतें पुरानी हो सकती हैं",
  "status": "स्टेटस",
  "submittingAlert": "बनाया जा रहा है...",
  "symbol": "सिंबल",
  "telegram": "टेलीग्राम",
  "topGainer": "सबसे ज़्यादा बढ़ने वाला",
  "topLoser": "सबसे ज़्यादा गिरने वाला",
  "totalListedCoins": "कुल लिस्टेड कॉइन",
  "trending": "ट्रेंडिंग",
  "volume": "वॉल्यूम",
  "volume24h": "24 घंटे वॉल्यूम",
  "website": "वेबसाइट"
}